import { render, staticRenderFns } from "./regist1.vue?vue&type=template&id=a7040dfe"
import script from "./regist1.vue?vue&type=script&lang=js"
export * from "./regist1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports